export default {
  CreateSettlementTitle: 'Elige una aseguradora',
  createSettlementDescription: 'Para continuar, selecciona una de las siguientes opciones',
  coverageSelection: 'Cobertura',
  coverageSelectionDescription: 'Elige una o más de las siguientes opciones',
  cutoffTitle: 'Periodo de corte',
  cutoffDescription: 'Selecciona un rango de fechas, inicio y fin',
  error: 'Ocurrió un error en la creación de la radicación',
  steper: { 
    sponsorSelection: "Selección de aseguradora",
    authorizations: "Autorizaciones"
  },
  buttons: {
    next: "Continuar",
    back: "Atrás",
    cancel: "Cancelar",
    end: "Finalizar",
    changeSponsor: "Cambiar"
  },
  title: {
    text: 'Nueva radicación',
    back: 'Cancelar'
  },
  dates: {
    init: "Desde",
    final: "Hasta"
  },
  authorizations: {
    cutoffRange: "Periodo de corte",
    totalResults: "{total} resultados",
    selectedRows: "{selected} seleccionados",
    chooseTitle: "Elige las autorizaciones que quieres radicar",
    chooseDescription: "Puedes deseleccionar autorizaciones",
    selectAll: "Seleccionar todas",
    grid: {
      id: "ID Autorización",
      createdAt: "Fecha creación",
      beneficiaryName: "Beneficiario",
      memberCode: "Carnet",
      coverage: "Cobertura"
    },
    manualAuthorizations: {
      select: "Incluir autorizaciones manuales",
      label: "Autorizaciones manuales",
      quantity: "Cantidad",
      amount: "Monto",
      errors: {
        quantityAndAmountRequired: "Debe ingresar la cantidad y el monto de las autorizaciones manuales",
        quantityAndAmountPositive: "La cantidad y el monto deben ser mayores a 0."
      }
    },
  },
  billing: {
    title: 'Finalizar radicación',
    subtitle: 'Ingresa la siguiente información',
    quantitySubtitle: 'No hay autorizaciones a radicar | 1 autorización a radicar | {n} autorizaciones a radicar',
    complete: "Finalizar",
    invoiceNumber: {
      label: 'No. de factura',
      placeholder: 'No. de factura'
    },
    invoiceDate: {
      label: 'Fecha de factura',
      placeholder: 'Fecha de factura'
    },
    invoiceAmount: {
      label: 'Monto total de la factura',
      placeholder: 'Monto total de la factura'
    },
    taxReceiptNumber: {
      label: 'NCF',
      placeholder: 'NCF'
    },
    taxReceiptNumberDate: {
      label: 'Fecha del comprobante fiscal',
      placeholder: 'Fecha del comprobante fiscal'
    },
    taxReceiptNumberExpirationDate: {
      label: 'Fecha de vencimiento del comprobante fiscal',
      placeholder: 'Fecha de vencimiento del comprobante fiscal'
    },
    invoiceFile: {
      label: 'Documento de factura',
      placeholder: 'Arrastra y suelta ó',
      placeholderDrag: "Arrastra y suelta",
      upload: "Subir archivo",
      replace: "Reemplazar"
    },
    creditNoteFile: {
      label: 'Nota de crédito (opcional)',
      placeholder: 'Arrastra y suelta ó',
      upload: "Subir archivo",
      placeholderDrag: "Arrastra y suelta",
      replace: "Reemplazar"
    },
    debitNoteFile: {
      label: 'Nota de débito (opcional)',
      placeholder: 'Arrastra y suelta ó',
      upload: "Subir archivo",
      placeholderDrag: "Arrastra y suelta",
      replace: "Reemplazar"
    },
    errors: {
      multipleFileUpload: "Solo se puede cargar un archivo a la vez",
      fileTypeIncorrect: "Tipo de archivo incorrecto"
    }
  }
}